import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "callback",
  style: {"background":"white"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { style: {"padding-top":"20px"} }, "轉換中，請稍後", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_spin, {
      size: "large",
      variant: "info"
    }),
    _hoisted_2
  ]))
}